/**
 * MobileMenuItem
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import clsx from 'clsx';
import Icon from '../Icon';
import { useUuid } from 'ui-component-library/hooks';
import { Transition } from 'react-transition-group';
import { Link as LinkBase } from 'ui-component-library/base';
/** Naviagation list with links. */
var MobileMenuItem = function (_a) {
    var menuLevel = _a.menuLevel, _b = _a.url, url = _b === void 0 ? '#' : _b, title = _a.title, _c = _a.isOpen, isOpen = _c === void 0 ? false : _c, _d = _a.isActive, isActive = _d === void 0 ? false : _d, openMenuItemLabel = _a.openMenuItemLabel, closeMenuItemLabel = _a.closeMenuItemLabel, _e = _a.LinkComponent, LinkComponent = _e === void 0 ? LinkBase : _e, _f = _a.isQuickLink, isQuickLink = _f === void 0 ? false : _f, children = _a.children;
    var getUuid = useUuid()[0];
    var _g = useState(isOpen), expanded = _g[0], setExpanded = _g[1];
    var id = getUuid();
    var Link = LinkComponent;
    var renderChildren = function (children) {
        return React.Children.map(children, function (child, index) {
            var props = child && child.props ? __assign({}, child.props) : {};
            props.openMenuItemLabel = openMenuItemLabel;
            props.closeMenuItemLabel = closeMenuItemLabel;
            return (React.createElement(React.Fragment, { key: index }, React.cloneElement(child, props || {})));
        });
    };
    return (React.createElement("li", null,
        React.createElement("div", { className: clsx(menuLevel === 0 &&
                'text-h4 bg-teal text-white border-white pl-4 border-b', menuLevel === 1 &&
                'text-h5 bg-white text-black border-greyLight pl-8 border-b', menuLevel === 2 &&
                'bg-greyLightest text-black border-greyLight pl-14 border-b', ' flex justify-between', isQuickLink && 'text-h4 text-teal border-b-2 border-greyLight pl-4') },
            React.createElement(Link, { to: url, className: "w-full my-3 hover:underline" }, title),
            children && (React.createElement("button", { "aria-controls": "menu-pane-" + id, "aria-expanded": expanded, "aria-label": (expanded ? closeMenuItemLabel : openMenuItemLabel) + " " + title, onClick: function () { return setExpanded(!expanded); }, className: "w-12 h-12" },
                React.createElement(Icon, { icon: expanded ? 'minus' : 'plus', "aria-hidden": true, size: 1.25, className: clsx(menuLevel === 0 && 'text-white', menuLevel === 1 && 'text-teal') })))),
        children && (React.createElement(Transition, { in: expanded, timeout: 200 }, function (state) { return (React.createElement("ul", { id: "menu-pane-" + id, className: clsx(state === 'exiting' ? 'animate-fade-out' : 'animate-fade-in'), hidden: state === 'exited' }, renderChildren(children))); }))));
};
export default MobileMenuItem;
